<template>
    <b-sidebar
        v-model="isOpen"
        id="sidebar-news-detail"
        right
        backdrop
        shadow
        width="60em"
        backdrop-variant="dark"
        @change="onSidebarChange"
    >
        <template #title>
            <div>
                <strong>📰 Новость</strong>
            </div>
        </template>
        
        <div class="p-3" v-if="news">
            <div class="mb-4">
                <h4><strong>{{ news.title }}</strong></h4>
                <small class="text-muted">
                    Опубликовано: {{ formatDate(news.published_at) }}
                </small>
            </div>
            
            <div v-if="news.image" class="mb-3">
                <img 
                    :src="getImageUrl(news.image)" 
                    :alt="news.title || 'Изображение новости'"
                    class="img-fluid rounded"
                    style="max-width: 100%;"
                    @error="handleImageError"
                />
            </div>
            
            <div v-if="news.content">
                <div class="news-content mt-2" v-html="formatContent(news.content)"></div>
            </div>
        </div>

        <template #footer>
            <div class="d-flex justify-content-end p-3">
                <b-button 
                    variant="outline-secondary" 
                    size="sm"
                    @click="closeSidebar"
                >
                    Закрыть новость
                </b-button>
            </div>
        </template>
    </b-sidebar>
</template>

<script>
import { HOST_FOR_STORAGE } from "@/constants";

export default {
    name: 'NewsDetailSidebar',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        news: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            hfs: HOST_FOR_STORAGE
        }
    },
    computed: {
        isOpen: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return '';
            
            // Если дата уже в формате d.m.Y H:i, просто возвращаем её
            if (typeof dateString === 'string' && dateString.match(/^\d{2}\.\d{2}\.\d{4}/)) {
                return dateString;
            }
            
            // Иначе пытаемся распарсить как ISO дату
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                return dateString; // Возвращаем как есть, если не удалось распарсить
            }
            
            return date.toLocaleDateString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        },
        
        formatContent(content) {
            if (!content) return '';
            // Простое форматирование - можно расширить для HTML
            return content.replace(/\n/g, '<br>');
        },
        
        closeSidebar() {
            this.isOpen = false;
        },
        
        onSidebarChange(isOpen) {
            if (!isOpen) {
                this.$emit('close');
            }
        },
        
        handleImageError(event) {
            // Скрываем изображение при ошибке загрузки
            event.target.style.display = 'none';
        },
        
        getImageUrl(imagePath) {
            if (!imagePath) return '';
            
            let finalUrl;
            
            // Если путь уже содержит полный URL, возвращаем как есть
            if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
                finalUrl = imagePath;
            }
            // Если путь начинается с /api/, используем HOST_FOR_STORAGE
            else if (imagePath.startsWith('/api/')) {
                finalUrl = this.hfs + imagePath.substring(5); // Убираем /api/ из начала
            }
            // Если путь содержит 'news/', формируем URL для новостей
            else if (imagePath.includes('news/')) {
                // Извлекаем имя файла из пути
                const fileName = imagePath.split('/').pop();
                finalUrl = this.hfs + 'news-image/' + fileName;
            }
            // Иначе добавляем HOST_FOR_STORAGE
            else {
                finalUrl = this.hfs + imagePath;
            }
            
            console.log('Image URL:', { original: imagePath, final: finalUrl }); // Отладка
            return finalUrl;
        }
    }
}
</script>

<style scoped>
.news-content {
    line-height: 1.6;
    color: #333;
}

.news-content h1, .news-content h2, .news-content h3, 
.news-content h4, .news-content h5, .news-content h6 {
    margin-top: 1rem;
    margin-bottom: 0.5rem;
}

.news-content p {
    margin-bottom: 1rem;
}

.news-content ul, .news-content ol {
    margin-bottom: 1rem;
    padding-left: 1.5rem;
}
</style>
